














import { Component, Mixins, Emit } from "vue-property-decorator";
import { SingleSelectableMixin } from "./mixins";

@Component({
})
export default class DropDownSelector extends Mixins(SingleSelectableMixin) {
  @Emit()
  selectorClicked(): void {}

  $refs!: {
    selector: HTMLSelectElement;
  };

  setFocus(): void {
    if (this.$refs.selector) {
      this.$refs.selector.focus();
    }
  }

  onSelectorClicked() {
    this.selectorClicked();
  }
}
